@if (appStore.companySettings().preferredAccountsSystemId >= 1) {
    <sf-callout color="success" icon="circle-check" iconColour="success">
        <p class="mb-0">Your Surefire subscription has already connected with an accounts integrator.</p>
        <p class="mb-0">
            <i
                >If you are having problems accessing your accounts integration or want to switch integration please get
                in touch with support.</i
            >
        </p>

        @if (appStore.me()?.loggedIntoAccounts) {
            <a sfButton class="mt-3" routerLink="/accounts-integration/dashboard">View Accounts Dashboard</a>
        } @else {
            <p class="mt-3 text-danger">Please authenticate using the required accounts integrator below.</p>
        }
    </sf-callout>
}

<div class="row g-1">
    <div class="col-md-4 col-lg-4 col-xxl-3">
        <div class="card" [class.border-success]="appStore.companySettings().preferredAccountsSystemId === 1">
            <img src="/assets/images/accounts/integrated-accounts-xero-logo.png" class="card-img-top" alt="Xero logo" />
            <div class="card-body">
                <h5 class="card-title">Xero</h5>
                <p>
                    Integrate your Surefire subscription with <b>Xero</b> to manage sales invoices, deposits/prepayments
                    and purchase invoices.
                </p>
            </div>
            <div class="card-footer">
                @if (appStore.companySettings().preferredAccountsSystemId === 1) {
                    <button sfButton type="button" [disabled]="true" color="success">Active</button>
                    <button sfButton type="button" color="secondary" (click)="selectXero()">Authenticate</button>
                } @else {
                    <button sfButton type="button" color="secondary" (click)="selectXero()">Start now</button>
                }
            </div>
        </div>
    </div>
    <div class="col-md-4 col-lg-4 col-xxl-3">
        <div class="card" [class.border-success]="appStore.companySettings().preferredAccountsSystemId === 2">
            <img
                src="/assets/images/accounts/integrated-accounts-quickbooks-logo.png"
                class="card-img-top"
                alt="Quickbooks logo" />
            <div class="card-body">
                <h5 class="card-title">Quickbooks</h5>
                <p>
                    Integrate your Surefire subscription with <b>Quickbooks</b> to manage sales invoices,
                    deposits/prepayments and purchase invoices.
                </p>
            </div>
            <div class="card-footer">
                @if (appStore.companySettings().preferredAccountsSystemId === 2) {
                    <button sfButton type="button" [disabled]="true" color="success">Active</button>
                    <button sfButton type="button" color="secondary" (click)="selectQuickbooks()">
                        Re-authenticate
                    </button>
                } @else {
                    <button
                        sfButton
                        type="button"
                        color="secondary"
                        [disabled]="!!appStore.companySettings().preferredAccountsSystemId"
                        (click)="selectQuickbooks()">
                        Start now
                    </button>
                }
            </div>
        </div>
    </div>
</div>
